import React from 'react'
import { getMessage } from 'lib/translator'
import { CategorySearch } from 'components/Form'
import { ReactComponent as CloseIcon } from 'icons/close-icon-grey.svg'

const RuleExclusionByOfferType = ({
  offerType,
  handleAddCategory,
  handleRemoveCategory,
}) => {
  const { description, categories } = offerType

  return (
    <div className="offer-type-content">
      <div className="offer-type-description">
        <h3>Description</h3>
        <p>{description}</p>
      </div>

      <div className="offer-type-categories">
        <h3>Categories</h3>
        <CategorySearch
          name="category"
          className="category-searchable"
          transformResponse={(response) => response.data.category}
          label={getMessage(`category.form.add.heading`)}
          placeholder={getMessage(`offer.category.placeholder`)}
          onChange={(value) => handleAddCategory(offerType, value)}
        />
        {categories?.length > 0 ? (
          <ul className="categories-list">
            {categories.map((category, index) => (
              <li key={category.id} className="category-item">
                {category.name} &nbsp;
                <span className="id-field">(id: {category.id})</span>
                <button
                  className="remove-icon"
                  data-testid={`remove-${index}`}
                  onClick={() => handleRemoveCategory(offerType, index)}
                >
                  <CloseIcon height={11} width={11} />
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <div className="empty-category-container">No added category</div>
        )}
      </div>
    </div>
  )
}

export default RuleExclusionByOfferType
